import { reactive, ref, watch, nextTick } from 'vue';
import type { OfferDto, OfferFormData } from '../types/offer.types';

export function useOfferForm(initialOffer: OfferDto | null = null) {
  const state = reactive<OfferFormData>({
    id: null,
    name: '',
    description: '',
    category_id: null,
    price: '',
    product_id: null,
    feature_values: [],
  });

  const productName = ref<string>('');
  const categoryName = ref<string>('');

  function applyOfferToForm(offer: OfferDto | null) {
    state.id = offer?.id ?? null;
    state.name = offer?.name ?? '';
    state.description = offer?.description ?? '';
    state.category_id = offer?.category_id ?? null;
    state.price = offer?.price ?? '';
    state.product_id = offer?.product_id ?? null;
    state.feature_values = offer?.feature_values ?? [];
    productName.value = offer?.product_name || '';
    categoryName.value = offer?.category_name || '';
  }

  function selectCategory(category: { id: number; name: string }) {
    state.category_id = category.id;
    categoryName.value = category.name;
  }

  function selectProduct(product: { id: number; name: string; description?: string | null }) {
    state.product_id = product.id;
    productName.value = product.name;
    if (!state.description) {
      state.description = product.description ?? '';
    }
  }

  function clearProduct() {
    state.product_id = null;
    productName.value = '';
  }

  function getFormData(): OfferFormData {
    return {
      id: state.id ?? null,
      name: state.name,
      description: state.description || null,
      category_id: state.category_id ?? null,
      price: state.price !== '' ? String(state.price) : null,
      product_id: state.product_id ?? null,
      feature_values: state.feature_values ?? [],
    };
  }

  // Initialize with provided offer
  if (initialOffer) {
    applyOfferToForm(initialOffer);
  }

  return {
    state,
    productName,
    categoryName,
    applyOfferToForm,
    selectCategory,
    selectProduct,
    clearProduct,
    getFormData,
  };
}